import React from 'react';
import { AppBar, Box, Toolbar, Typography, IconButton, Avatar } from '@mui/material';
import MenuIcon from '@mui/icons-material/MenuOutlined';

import { useAuth } from '../../auth/contexts/AuthenticationContext';
import { displayNameFor } from '../../auth/helpers';
import { initialsForUser } from '../../../shared/utils/dates';
import AccountSwitcher from '../../auth/components/AccountSwitcher';

import { DRAWER_WIDTH } from './Sidebar';

interface TopNavigationProps {
  onMenuClick?: () => void;
  bannerOffset?: number;
}

export default function TopNavigation({ onMenuClick, bannerOffset = 0 }: TopNavigationProps) {
  const { user } = useAuth();
  const displayName = displayNameFor(undefined, user);
  const initials = initialsForUser(user);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        top: `${bannerOffset}px`,
        width: { md: `calc(100% - ${DRAWER_WIDTH}px)` },
        ml: { md: `${DRAWER_WIDTH}px` },
        backgroundColor: '#fff',
        borderBottom: '1px solid #e5e7eb',
      }}
    >
      <Toolbar sx={{ minHeight: '64px !important' }}>
        <IconButton
          edge="start"
          aria-label="Open navigation"
          onClick={onMenuClick}
          sx={{ display: { xs: 'inline-flex', md: 'none' }, mr: 1, color: '#333' }}
        >
          <MenuIcon />
        </IconButton>

        <Box
          component="img"
          src="/wz-icon-blue.png"
          alt=""
          sx={{ display: { xs: 'block', md: 'none' }, width: 30, height: 30, objectFit: 'contain' }}
        />

        <Box sx={{ flexGrow: 1 }} />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Box sx={{ textAlign: 'right', display: { xs: 'none', sm: 'block' } }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#333', lineHeight: 1.3 }}>
              {displayName}
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#999', lineHeight: 1.3 }}>
              {user?.email || ''}
            </Typography>
          </Box>
          <AccountSwitcher
            trigger={
              <IconButton sx={{ p: 0.5 }}>
                <Avatar sx={{ width: 36, height: 36, backgroundColor: 'primary.main', fontSize: '14px', fontWeight: 600 }}>
                  {initials}
                </Avatar>
              </IconButton>
            }
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
}
